export default "__VITE_ASSET__Cgk4150n__"